import Card from '@/components/card/card-component';
import { Row } from '@/components/grid/grid-component';
import { BodyText, BodyTextLarge, SubheaderText } from '@/utils/global-fonts';
import { BsX } from 'react-icons/bs';
import { FiEdit } from 'react-icons/fi';
import styled from 'styled-components';

const CardStyle = styled(Card)`
  border: none;
`;

const ModuleCard = styled(Card)``;

const AddModuleCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #ccd0e3;
  width: auto;
  height: 100%;
`;

const AddModuleRow = styled(Row)`
  display: flex;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  cursor: pointer;
`;

const RowStyle = styled(Row)`
  margin-left: 0 !important;
  margin-right: 0 !important;
`;

const Line = styled.div`
  border-bottom: 1px solid #ccc;
  width: inherit;
`;

const HeadingDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const IconDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const Title = styled(SubheaderText)``;

const Description = styled(BodyText)`
  margin-bottom: 10px;
`;

const EditIcon = styled(FiEdit)`
  cursor: pointer;
`;

const DeleteIcon = styled(BsX)`
  margin-left: 4px;
  cursor: pointer;
`;

const AddModuleText = styled(BodyTextLarge)`
  margin-top: 14px;
`;

const Container = styled.div`
  /* margin: 0 0 12px 0; */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 14px;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 4px;
`;

const LabelText = styled.label`
  color: ${(props) => props.theme.COLOR_GREY_TEXT};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 16px;
  text-align: left;
`;

const StyledQuotingModule = {
  CardStyle,
  RowStyle,
  Container,
  Title,
  ModuleCard,
  AddModuleCard,
  Description,
  EditIcon,
  DeleteIcon,
  HeadingDiv,
  IconDiv,
  LabelText,
  Line,
  AddModuleRow,
  AddModuleText,
};

export default StyledQuotingModule;
